import { render } from "./GastosView.vue?vue&type=template&id=0eabf21b&scoped=true"
import script from "./GastosView.vue?vue&type=script&lang=js"
export * from "./GastosView.vue?vue&type=script&lang=js"

import "./GastosView.vue?vue&type=style&index=0&id=0eabf21b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eabf21b"]])

export default __exports__